import { render, staticRenderFns } from "./AdminSitesCard.vue?vue&type=template&id=f12e6f92"
import script from "./AdminSitesCard.vue?vue&type=script&lang=js"
export * from "./AdminSitesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports